import { render, staticRenderFns } from "./openAccountResult.vue?vue&type=template&id=392c572a&scoped=true"
import script from "./openAccountResult.vue?vue&type=script&lang=js"
export * from "./openAccountResult.vue?vue&type=script&lang=js"
import style0 from "./openAccountResult.vue?vue&type=style&index=0&id=392c572a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c572a",
  null
  
)

export default component.exports